export const handicapList = ['0', '0/0.5', '0.5', '0.5/1', '1', '1/1.5', '1.5', '1.5/2', '2', '2/2.5', '2.5', '2.5/3', '3', '3/3.5', '3.5', '3.5/4', '4', '4/4.5', '4.5', '4.5/5', '5', '5/5.5', '5.5', '5.5/6', '6', '6/6.5', '6.5', '6.5/7', '7', '7/7.5', '7.5', '7.5/8', '8', '8/8.5', '8.5', '8.5/9', '9', '9/9.5', '9.5', '9.5/10', '10', '10/10.5', '10.5', '10.5/11', '11', '11/11.5', '11.5', '11.5/12', '12', '12/12.5', '12.5', '12.5/13', '13', '13/13.5', '13.5', '13.5/14', '14', '14/14', '14.5', '14.5/15', '15', '15/15.5', '15.5', '15.5/16', '16', '16/16.5', '16.5', '16.5/17', '17', '17/17.5', '17.5', '17.5/18', '18', '18/18.5', '18.5', '18.5/19', '19', '19/19.5', '19.5', '19.5/20', '20']
export const common = {
  previousStep: 'Terakhir',
  nextStep: 'Berikutnya',
  close: 'Menutup',
  notFoundText: 'Maaf, halaman yang Anda cari tidak ada',
  euro: 'EUR',
  dollar: 'USD',
  pound: 'GBP',
  rmb: 'RMB',
  cancel: 'Batal',
  mounth: 'Bulan'
}
export const noticeView = {
  loading: 'Sedang dimuat...',
  netError: 'kesalahan koneksi Internet',
  noData: 'Tiada data tersedia',
  refreshBtnTitle: 'Klik untuk refresh'
}
export const integral = {
  rank: 'Pos',
  teamName: 'Tim',
  scene: 'Main',
  result: 'M/S/K',
  gainAndLoss: 'MG/KG',
  integral: 'Poin',
  leagueFormat: 'Format'
}
export const btnList = {
  schedule: 'Jadwal',
  integral: 'Klasemen',
  playerList: 'Pemain',
  oddsStatistics: 'Stat.AH'
}
export const integralBtnList = {
  totalIntegral: 'Total',
  homeIntegral: 'Kandang',
  guestIntegral: 'Tandang'
}
export const players = {
  shooters: 'Top skor',
  own: 'Gol Bunuh Diri',
  yellowCard: 'Kartu Kuning',
  redCard: 'Kartu Merah',
  showAll: 'Cek semua',
  rank: 'Pos',
  player: 'Pemain',
  teamName: 'Tim',
  total: 'Total'
}
export const oddsStatistics = {
  totalCourt: 'Total Pertandingan',
  homeCourt: 'Kandang',
  guestCourt: 'Tandang',
  matchCount: 'Pertandingan',
  hasOdds: 'Pasaran Terbuka',
  han: 'Tim Favorit',
  winAndLoss: 'M/P/K',
  goalDifference: 'Menang',
  winningRate: 'WR',
  dataStatistics: 'Stat.AH',
  winMost: 'Win Rate Tertinggi',
  homeWin: 'Kandang Menang',
  draw: 'Push',
  guestWin: 'Tandang Menang',
  site: 'Main',
  btnWin: 'Menang',
  btnDraw: 'Push',
  winRate: 'WR'
}
export const scheduleNotesTitle = {
  halfCourt: 'HT',
  fullHalf: 'FH/HT',
  singleAndDouble: 'Ganjil/Genap',
  letBall: 'Handicap',
  runTitle: 'Ke-',
  runTitle1: 'Ronde'
}
export const playerInfo = {
  playingTeam: 'Klub',
  playerHonor: 'Kehormatan tim',
  playerProfile: 'Profil',
  currentTeam: 'Tim saat ini',
  joinTime: 'Tangal Bergabung',
  salary: 'Gaji',
  formerTeam: 'Mantan Klub ',
  previousTeam: 'Klub yang pernah bergabung',
  transferFee: 'Biaya transfer'
}
export const playerIndex = {
  height: 'Tinggi',
  bodyWeight: 'Berat',
  worth: 'Nilai Pasar',
  playerInfo: 'Infomasi Pemain',
  playerStats: 'Satistik',
  playerPosition: 'Posisi Pemain',
  jerseyNumber: 'NO.',
  numberName: 'Nomor',
  ouYuan: 'EUR',
  meiYuan: 'USD',
  yingBang: 'GBP',
  renMinBi: 'RMB',
  wan: '10RB'
}
export const teamIndex = {
  founded: 'Dirikan',
  officialWebsite: 'Website resmi',
  fixture: 'Jadwal',
  trackRecord: 'Catatan Seblumnya',
  stats: 'Data',
  lineUp: 'Lineup',
  playerList: 'Pemain',
  info: 'Infomasi',
  transfer: 'Transfer',
  totalPrice: 'Nilai total',
  record: 'Catatan belakangan ini',
  win: 'Menang',
  draw: 'Seri',
  loss: 'Kalah'
}
export const dataStatistics = {
  twoYearData: 'Data dalam 2 tahun terakhir',
  jinQiu: 'Gol',
  dianQiu: 'Penalti',
  wuLong: 'Gol Bunuh Diri',
  huangPai: 'Kartu Kuning',
  hongPai: 'Kartu Merah',
  duiZhen: 'H2H'
}
export const teamTrackRecord = {
  confrontationRecordTitle: '20 Pertemuan terakhir',
  latelyHandicap: 'Hasil Taruhan 20 laga terakhir',
  win: 'Menang',
  win1: 'Menang',
  draw: 'Seri',
  lose: 'Kalah',
  lose1: 'kalah',
  winRatio: 'Win Rate',
  payoutWinRatio: 'AH Win Rate',
  overRatio: 'Over Rate',
  singleDigitRatio: 'Odd Rate',
  sectionTitle: '20 Laga terakhir',
  home: 'Kandang',
  away: 'Tandang',
  neutralCourt: 'Neutral',
  homeWin: 'Kandang Menang',
  homeDraw: 'Seri',
  homeLose: 'Kandang Kalah',
  game: 'Main',
  over: 'Over',
  halfOver: 'Over(HT）',
  under: 'Under',
  halfUnder: 'Under(HT)',
  single: 'Ganjil',
  double: 'Genap',
  by: '+'
}
export const teamTransfer = {
  zhuanRu: 'Bergabung',
  zhuanChu: 'Tinggalkan'
}
export const stats = {
  total: 'Total',
  home: 'Kandang',
  neutralCourt: 'Neutral',
  away: 'Kandang',
  goalDifferenceTitle: 'Statistik Gol Difference(（kali）',
  goalDifference: 'Diff.',
  draw: 'Seri',
  netNegative: 'Kalah',
  goalTitle: 'Statistik Gol Masuk(kali)',
  goalCount: 'Jumlah Gol',
  handicapTitle: 'Statisik Tim Favorits&Underdoog',
  homeHandicap: 'Tim Favorit',
  drawHandicap: 'Push',
  guestHandicap: 'Tim Underdog',
  win1: 'Menang',
  draw1: 'Push',
  lose1: 'Kalah',
  goalStatsTitle: 'Statistik Gol Masuk(Kali)',
  ball: 'Bola',
  single: 'Ganjil',
  double: 'Genap'
}
export const lineUp = {
  coach: 'Pelatih',
  forward: 'Penyerang',
  centerForward: 'Gelandang',
  guard: 'Bek',
  goalkeeper: 'Kiper',
  numberTitle: 'Nomor'
}
export const coach = {
  sg_tz: 'Tinggi/Berat',
  renJiaoQiuHui: 'Tim berlatih',
  xianShuQiuDui: 'Tim ssat ini',
  qianDuQiuDui: 'Mantan Klub',
  cengXiaoLiQiuDui: 'Klub yang pernah bergabung',
  qiuYuanRongYu: 'Kehormatan pemain',
  jieShao: 'Profil',
  shengRi: 'Lahir',
  guoJi: 'Kebangsaan'
}
export const teamInfo = {
  basicInfo: 'Infomasi dasar',
  city: 'Kota',
  homeCourt: 'Lapangan',
  capacity: 'Kapasitas',
  address: 'ALamat',
  honour: 'Kehormatan tim',
  summary: 'Profil'
}
